var render = function render() {
  var _vm = this,
      _c = _vm._self._c;

  return _c('div', {
    staticClass: "el-sp-right"
  }, [_c('div', {
    staticClass: "el-sp-right__header"
  }, [_c('span', [_vm._v("已选择 (" + _vm._s(_vm.selected.length) + ")")]), _vm.selected.length > 1 ? _c('div', {
    staticClass: "el-sp-right__links"
  }, [_c('el-link', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.selectAllOrClear
    }
  }, [_vm._v("全选/清除")])], 1) : _vm._e()]), _c('div', {
    class: _vm.selected.length > 0 ? 'el-sp-items' : 'el-sp-items-empty'
  }, [_vm.selected.length == 0 ? _c('div', {
    staticClass: "el-item-empty"
  }, [_c('img', {
    staticStyle: {
      "height": "100px"
    },
    attrs: {
      "src": _vm.emptyIcon
    }
  }), _c('span', {
    staticClass: "font-size mt-10"
  }, [_vm._v("请选择关联对象")])]) : [_c('ul', {
    staticClass: "el-sp-right__list"
  }, [_c('li', {
    staticClass: "el-sp-right__item"
  }, [_c('b', {
    staticClass: "el-sp-right__item__name"
  }, [_vm._v(_vm._s(_vm.theadData.name))]), _c('b', {
    staticClass: "el-sp-right__item__id"
  }, [_vm._v(_vm._s(_vm.theadData.id))]), _c('b', {
    staticClass: "el-sp-right__item__dept"
  }, [_vm._v(_vm._s(_vm.theadData.dept))]), _c('b', {
    staticClass: "el-sp-right__item__delete"
  }, [_vm._v("删除")])]), _vm._l(_vm.selected, function (option, index) {
    return _c('li', {
      key: index,
      staticClass: "el-sp-right__item",
      class: {
        'el-sp-right__item--active': option.active
      }
    }, [_c('span', {
      staticClass: "el-sp-center__item__name",
      attrs: {
        "title": option.name
      },
      on: {
        "click": function ($event) {
          return _vm.checkItem(option);
        }
      }
    }, [_vm._v(" " + _vm._s(option.name) + " ")]), _c('span', {
      staticClass: "el-sp-center__item__id",
      attrs: {
        "title": option.id
      },
      on: {
        "click": function ($event) {
          return _vm.checkItem(option);
        }
      }
    }, [_vm._v(" " + _vm._s(option.id) + " ")]), _c('span', {
      staticClass: "el-sp-center__item__dept",
      attrs: {
        "title": option.dept
      },
      on: {
        "click": function ($event) {
          return _vm.checkItem(option);
        }
      }
    }, [_vm._v(" " + _vm._s(option.dept) + " ")]), _c('i', {
      staticClass: "we-sp-right__item__delete el-icon-delete",
      on: {
        "click": function ($event) {
          $event.stopPropagation();
          return _vm.deleteRecords_in(option);
        }
      }
    })]);
  })], 2)]], 2)]);
};

var staticRenderFns = [];
export { render, staticRenderFns };